import {useContext} from 'react'

import {ProjectsContext} from './ProjectsContext.tsx'

export const useProjects = () => {
  const contextInstance = useContext(ProjectsContext)
  if (!contextInstance) throw new Error('Cannot call useProjects() outside of <ProjectsProvider>')
  return contextInstance
}
